/** GraphQL Mutation that creates new customer address. */
export default `
  mutation createCustomerV2($input: CustomerCreateInput!) {
    createCustomerV2(input: $input) {
      customer {
        addresses {
            city
            country_code
            firstname
            lastname
            postcode
            region {
            region_code
            region_id
            region
            }
            street
            vat_id
            telephone
        }
        allow_remote_shopping_assistance
        consent_to_email_commercials
        consent_to_phone_commercials
        consent_to_rules
        created_at
        date_of_birth
        default_billing
        default_shipping
        email
        firstname
        gender
        is_b2b
        is_subscribed
        lastname
        middlename
        prefix
        sales_channel
        suffix
        taxvat
      }
    }
  }
`;
